import { FC, useState } from 'react';
import { useStyles } from './styles';
import { useStore } from 'hooks/useRootStore';
import { useAppPreloader } from 'hooks/useAppPreloader';
import { useMutation } from 'react-query';
import { Grid, TextField, Button, Paper } from '@material-ui/core';
import { observer } from 'mobx-react-lite';
import { ReactComponent as LogoIcon } from 'assets/logo.svg';
import { useHistory } from 'react-router';
import { handleCompanyUrl } from 'utils/organizationUtils';

const RecoveryCode: FC = observer(() => {
  const classes = useStyles();
  const history = useHistory();
  const {
    userStore: { RecoveryCodeVerify },
    notificationStore: { openNotification },
  } = useStore();
  const tokens = localStorage.getItem('token');
  const profile = JSON.parse(localStorage.getItem('Profile') as string);
  const VertifyRequest = useMutation(
    () => {
      return RecoveryCodeVerify({ code });
    },
    {
      mutationKey: 'VertifyRequest',
      onSuccess: () => {
        profile.permission !== 'EndUser'
          ? history.push(handleCompanyUrl('/dashboard'))
          : tokens && profile?.permission === 'EndUser'
          ? history.push(handleCompanyUrl('/admin/profile'))
          : history.push(handleCompanyUrl('/reports'));
      },
      onError: ({ message }: Error) => {
        openNotification('error', message ? message : 'Something went wrong');
      },
    }
  );
  const [code, setCode] = useState<string>('');
  const handleCode = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    const value = event.target.value;
    setCode(value);
  };
  useAppPreloader(VertifyRequest.isLoading);
  return (
    <Grid item className={classes.container}>
      <div className={classes.topBars}>
        <LogoIcon style={{ marginLeft: '40px', width: '140px', height: '52px' }} />
      </div>
      <Grid container className={classes.main} justify='center'>
        <Grid item lg={4}>
          <Paper className={classes.paper} elevation={3}>
            <h1 className={classes.title}>Two Factor Recovery Code</h1>
            <Grid container justify='center' style={{ marginTop: '20px' }}>
              <p>
                If you are unable to access your mobile device, please enter one of your recovery codes to verify your
                identity.
              </p>
            </Grid>
            <Grid container justify='center'>
              <TextField
                className={classes.formControl}
                id='code'
                value={code}
                onChange={handleCode}
                required
                fullWidth
                placeholder='Enter Code'
                variant='outlined'
                label=''
                autoFocus
              />
            </Grid>
            <Grid className={classes.formControl} container justify='space-between'>
              <Button
                className={classes.button}
                variant='contained'
                color='primary'
                onClick={() => {
                  VertifyRequest.mutate();
                }}
              >
                Verify
              </Button>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </Grid>
  );
});

export default RecoveryCode;
